import React from 'react';
import PropTypes from 'prop-types';
import { clientLogger } from '../../../lib/logger';

const Feature = ({ componentContent = {}, handleClickFPTI }) => {
  const { title, desc, icon, fptiLinkName, alt } = componentContent;

  let imgAlt = alt ? alt : '';

  return (
    <div className="details-whats-included-item">
      <div className="details-features-icon">
        <svg className="details-features-svg">
          <image className="details-features-image" href={icon} alt={imgAlt} />
        </svg>
      </div>
      <h3 dangerouslySetInnerHTML={{ __html: title }}></h3>
      <p
        dangerouslySetInnerHTML={{ __html: desc }}
        onClick={e =>
          e.target.tagName === 'A' && fptiLinkName
            ? handleClickFPTI(fptiLinkName)
            : {}
        }
        role="presentation"
      ></p>
    </div>
  );
};

const IncludedFeatures = ({ featureItemValues, handleClickFPTI, toolName }) => {
  try {
    if (!Array.isArray(featureItemValues) || !featureItemValues.length) {
      clientLogger.warn('Feature row content unavailable');
      return null;
    }

    return (
      <div className="details-whats-included-items">
        {featureItemValues.map((featureContent, i) => (
          <Feature
            key={`details-whats-included-item-${i}`}
            componentContent={featureContent}
            handleClickFPTI={handleClickFPTI}
            toolName={toolName}
          />
        ))}
      </div>
    );
  } catch (error) {
    clientLogger.warn('Error rendering Details Feature Section', error);
    return null;
  }
};

IncludedFeatures.propTypes = {
  featureItemValues: PropTypes.array,
  handleClickFPTI: PropTypes.func,
  toolName: PropTypes.string
};

Feature.propTypes = {
  componentContent: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  toolName: PropTypes.string
};

export default IncludedFeatures;
